import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../core.state';
import { OAuthService } from 'angular-oauth2-oidc';
import { authModuleConfig } from 'app/auth';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private oAuthService: OAuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
    if (this.oAuthService.hasValidAccessToken()) {
      return true;
    }
    this.router.navigate([authModuleConfig.loginPageRoute]);
    return false;
  }
}
